export const adminHubRoutes = {
  adminHubCalendar: '/admin-hub/calendar'
};
